/**
 * @generated SignedSource<<6599bbd0c5491727fb6feadbba60d082>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type HorizontalNavProjectBreadcrumbs$data = {
  readonly key: string;
  readonly name: string;
  readonly " $fragmentType": "HorizontalNavProjectBreadcrumbs";
};
export type HorizontalNavProjectBreadcrumbs$key = {
  readonly " $data"?: HorizontalNavProjectBreadcrumbs$data;
  readonly " $fragmentSpreads": FragmentRefs<"HorizontalNavProjectBreadcrumbs">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "HorizontalNavProjectBreadcrumbs",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ],
  "type": "JiraProject"
};

(node as any).hash = "13d44dc1ebad4edb2d5c4498a1898152";

export default node;
